import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdateSaleInvoiceInstalmentTable } from 'store/saleInvoices/services/patchUpdateSaleInvoiceInstalmentTable';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

// Silent variant used by the sale-invoice-draft coupling (marking instalments
// INVOICED on import and reverting them on draft delete). The slice keeps
// this thunk snackbar-free; callers fire-and-forget with a console.error.
export const updateInstalmentTableRowStatuses = createAsyncThunk(
  'saleInvoices/updateInstalmentTableRowStatuses',
  async ({ tableId, rows }, { getState }) => {
    if (!tableId) {
      throw new Error('No instalment table id provided');
    }

    const selectedProjectId = selectSelectedProjectId(getState());

    const updatedInstalmentTable = await patchUpdateSaleInvoiceInstalmentTable(
      selectedProjectId,
      tableId,
      { rows }
    );

    return updatedInstalmentTable;
  }
);
